<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import Icon from "@/Components/Icon.vue";

const route = inject("route");
const { t } = useI18n();
import calendar from "@i/calendar.svg";
import user from "@i/user-icon.svg";
import search from "@i/search-icon.svg";
</script>
<template>
  <div class="relative bg-white py-20">
    <!-- Background Image -->
    <div class="absolute inset-0 z-0">
      <img
        src="@/../img/home/doctor-team2.png"
        alt="Background"
        class="w-full h-full object-cover opacity-30"
      />
    </div>
    <!-- Content -->
    <div class="relative z-10 max-w-5xl mx-auto px-4 text-center">
      <h2 class="text-4xl md:text-5xl mb-16">{{ t("Onze Diensten voor Werkgevers") }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-10 text-left">
        <!-- Box 1 -->
        <div class="p-6">
          <div class="text-green-600 mb-4">
            <Icon :icon="user" class="w-14 mb-4" />
          </div>
          <h3 class="text-lg font-bold mb-2">{{ t("Flexibele Personeelsoplossingen") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Maatwerk in uitzenden van gekwalificeerd zorgpersoneel voor kortdurende opdrachten en acute personeelstekorten.") }}</p>
        </div>
        <!-- Box 2 -->
        <div class="p-6">
          <div class="text-green-600 mb-4">
            <Icon :icon="user" class="w-14 mb-4" />
          </div>
          <h3 class="text-lg font-bold mb-2">{{ t("Detachering") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Professionele zorgmedewerkers voor langdurende projecten en tijdelijke vervangingen bij ziekte of zwangerschap.") }}</p>
        </div>
        <!-- Box 3 -->
        <div class="p-6">
          <div class="text-green-600 mb-4">
            <Icon :icon="search" class="w-14 mb-4" />
          </div>
          <h3 class="text-lg font-bold mb-2">{{ t("Werving & Selectie") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Vind de perfecte kandidaat voor uw vaste functies met onze expertise in personeelsplanning en capaciteitsbeheer.") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>